import {
  TOGGLE_RIGHT_DOCK,
  SET_ACTIVE_TAB,
  TOGGLE_EDITOR_DOCKED,
  TOGGLE_GALLERY_DOCKED,
  SET_DOCK_WIDTH
} from '../actions/rightDock.js';
import { CLEAR_USER } from '../actions/user.js';

const DEFAULT_WIDTH = 400;
const MIN_WIDTH = 400;
const MAX_WIDTH_VW = 80;

const INITIAL_RIGHT_DOCK_STATE = {
  visible: false,
  activeTab: 'editor',
  editorDocked: false,
  galleryDocked: false,
  width: DEFAULT_WIDTH
};

function rightDock(
  state = INITIAL_RIGHT_DOCK_STATE,
  action
) {
  switch (action.type) {
    case TOGGLE_RIGHT_DOCK:
      if (typeof action.data === 'boolean') {
        return Object.assign({}, state, { visible: action.data });
      }
      return Object.assign({}, state, { visible: !state.visible });

    case SET_ACTIVE_TAB:
      if (action.data === 'editor' || action.data === 'gallery') {
        return Object.assign({}, state, { activeTab: action.data });
      }
      return state;

    case TOGGLE_EDITOR_DOCKED:
      if (typeof action.data === 'boolean') {
        return Object.assign({}, state, { editorDocked: action.data });
      }
      return Object.assign({}, state, { editorDocked: !state.editorDocked });

    case TOGGLE_GALLERY_DOCKED:
      if (typeof action.data === 'boolean') {
        return Object.assign({}, state, { galleryDocked: action.data });
      }
      return Object.assign({}, state, { galleryDocked: !state.galleryDocked });

    case SET_DOCK_WIDTH:
      // Clamp width between min and max
      const maxWidth = (window.innerWidth * MAX_WIDTH_VW) / 100;
      const newWidth = Math.max(MIN_WIDTH, Math.min(maxWidth, action.data));
      return Object.assign({}, state, { width: newWidth });

    case CLEAR_USER:
      return INITIAL_RIGHT_DOCK_STATE;

    default:
      return state;
  }
}

export default rightDock;

